import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Link, useParams } from "react-router-dom";


/**
 * BankDetailsAdded component displays a success message after bank account submission.
 * Provides navigation to bank/pancard details page.
 */
const BankDetailsAdded = ({ login = null }) => {
  const { userId } = useParams();
  const [redirectUrl] = useState('customer')
  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-6 mt-10 pancard-data">
            <div className="text-center mb-7">
              <img
                width="300"
                alt="icon"
                src={toAbsoluteUrl("/media/images/new1-success.png")}
              />
            </div>
          </div>

          <div className="col-md-6 mt-10 pancard-data">
            <div className="mt-15">
              <h1 className="mb-5">Success</h1>
              <p>Your Bank Account has been successfully Submitted</p>
              <div className="mt-2 d-flex justify-content-center ">
                {/* <Link to={`/${redirectUrl}/bankpancard-details/${userId}`}>
                  <button className="btn btn-lg w-200px btn-danger text-white">OK</button>
                </Link> */}
                <Link to={`/${redirectUrl}/bankpancard-details/${userId}`}>
                  <button className="btn btn-lg w-200px btn-danger text-white">OK</button>
                </Link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BankDetailsAdded;
